

import { BidiModule } from '@angular/cdk/bidi';
import { LayoutModule } from '@angular/cdk/layout';
import { PlatformModule } from '@angular/cdk/platform';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MwcColDirective } from './col.directive';
import { MwcRowDirective } from './row.directive';

@NgModule({
  declarations: [MwcColDirective, MwcRowDirective],
  exports: [MwcColDirective, MwcRowDirective],
  imports: [BidiModule, CommonModule, LayoutModule, PlatformModule]
})
export class MwcGridModule {}
